import { useEffect, useState } from "react";
import { card, panel } from "@/lib/ops";

const LABEL = { home_view: "Homepage visits", program_view: "Program page views", register_click: "Register clicks", option_selected: "Class / session selected", checkout_started: "Checkout started", registration_completed: "Registration paid" };

export default function FunnelCard({ api }) {
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/funnel", { days }).then(setD); }, [api, days]);
  if (!d) return null;
  const max = Math.max(1, ...d.steps.map((s) => s.count));
  return (
    <div data-testid="funnel-card" className={panel}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div><h2 className="text-xl font-extrabold">Registration funnel</h2><p className="text-xs text-slate-500">Anonymous counts — no names or athlete details collected. Visitors counted once per day per step.</p></div>
        <select data-testid="funnel-days" value={days} onChange={(e) => setDays(Number(e.target.value))} className="rounded-xl border border-slate-200 px-3 py-2 text-sm">{[7, 30, 90].map((n) => <option key={n} value={n}>Last {n} days</option>)}</select>
      </div>
      <div className="mt-4 space-y-2">
        {d.steps.map((s) => (
          <div key={s.event} data-testid={`funnel-${s.event}`} className="grid grid-cols-[170px_1fr_110px] items-center gap-3 text-sm">
            <span className="font-semibold">{LABEL[s.event]}</span>
            <span className="h-3 rounded-full bg-slate-100"><span className="block h-3 rounded-full bg-[#2563EB]" style={{ width: `${(100 * s.count) / max}%` }} /></span>
            <span className="text-right tabular-nums"><b>{s.count}</b>{s.from_previous_pct != null && <span className="text-slate-500"> · {s.from_previous_pct}%</span>}</span>
          </div>
        ))}
      </div>
      <p className={`${card} mt-4 text-sm`}><b>{d.abandoned_checkouts}</b> checkout(s) started but not paid since {d.since}.</p>
    </div>
  );
}
